{
  "supplier": {
    "currencyLoadError": "تعذّر تحميل خيارات العملات. أعد المحاولة لاختيار عملة. تحتفظ الصفحة بالبيانات الأخرى التي أدخلتها.",
    "currencyKept": "العملة الحالية محفوظة:"
  },
  "agreement": {
    "emptyFiltered": "لا توجد اتفاقيات مطابقة لهذه التصفية",
    "emptyFilteredHint": "غيّر التصفية أو امسحها لعرض اتفاقيات أخرى.",
    "filterTitle": "تصفية الاتفاقيات",
    "showAgreements": "عرض الاتفاقيات",
    "showCount": "عرض الاتفاقيات: {{count}}",
    "lineOrderable": "قابل للطلب الآن",
    "orderableNow": "قابلة للطلب الآن",
    "orderableOnly": "القابلة للطلب الآن فقط",
    "emptyBlocked": "{{reason}}. لا يمكن الطلب من هذه الاتفاقية ما دام ذلك قائماً.",
    "emptyAlsoNoLines": "وليس فيها بنود مسعّرة أيضاً، فأضف بنداً بعد معالجة ذلك.",
    "emptyReady": "هذه الاتفاقية سارية والمورد مؤهل، لكن لا توجد فيها بنود مسعّرة بعد، فلا يمكن الطلب منها. أضف بنداً مسعّراً."
  },
  "unusable": {
    "agreement_no_priced_lines": "لا توجد بنود مسعّرة",
    "agreement_no_orderable_lines": "لا يوجد بند قابل للطلب الآن",
    "agreement_item_not_in_catalogue": "غير متاح في الكتالوج"
  },
  "qualification": {
    "reasonField": "سبب المراجعة أو الأدلة",
    "reasonRequiredHint": "مطلوب لهذا القرار. اذكر السبب ليمكن تفسيره لاحقاً.",
    "reasonOptionalHint": "اختياري. ما جرى فحصه أو سبب القرار، مثل المستندات التي روجعت. يُحفظ مع القرار واسمك ووقته.",
    "reviewRequiredHint": "مطلوب لهذا القرار. اذكر ما جرى فحصه وما أظهره، مثل المستندات التي روجعت. يُحفظ مع القرار واسمك ووقته.",
    "reliesOnReview": "سيستند هذا التفعيل إلى المراجعة المسجّلة عند اعتماد التأهيل:",
    "reliesOnReviewHint": "اختياري. أضف ما جرى فحصه منذ الاعتماد، مثل شهادة مجدَّدة. يُحفظ مع القرار واسمك ووقته.",
    "noReasonRecorded": "لم يُسجَّل سبب"
  }
}
